import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { nav } from '../data/site';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <>
      <header className="fixed inset-x-0 top-0 z-50 px-4 pt-4 sm:px-6 sm:pt-6" data-id="element-105" data-mp="1yo3ufjoxjo4p">
        <motion.nav initial={{
        opacity: 0,
        y: -16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className={`mx-auto flex max-w-[92rem] items-center justify-between rounded-full px-5 py-3 transition-all duration-700 ease-editorial sm:px-7 ${scrolled ? 'border border-charcoal/[0.07] bg-ivory/80 shadow-[0_8px_40px_-24px_rgba(34,34,34,0.35)] backdrop-blur-xl' : 'border border-transparent'}`} data-id="element-106" data-mp="23pt4ox4bvxrq">
          <Link to="/" className="font-sans text-[0.8125rem] font-medium uppercase tracking-[0.32em] text-charcoal" data-id="element-107" data-mp="2cuur374p2bqh">
            Amoye&nbsp;Henry
          </Link>

          <ul className="hidden items-center gap-7 lg:flex" data-id="element-108" data-mp="2351fw78grymr">
            {nav.slice(1).map(item => <li key={item.to} data-id="element-109" data-mp="30k5lm6vgb9w6">
                <NavLink to={item.to} className={({
              isActive
            }) => `link-underline text-[0.8125rem] tracking-[0.02em] transition-colors duration-300 ${isActive ? 'text-mocha' : 'text-charcoal/70 hover:text-charcoal'}`} data-id="element-110" data-mp="30lgxyv2yppyw">
                  {item.label}
                </NavLink>
              </li>)}
          </ul>

          <div className="flex items-center gap-3" data-id="element-111" data-mp="p5geyvrn5gb3">
            <Link to="/contact" className="hidden rounded-full bg-charcoal px-5 py-2.5 text-[0.75rem] font-medium uppercase tracking-[0.14em] text-ivory transition-colors duration-500 hover:bg-mocha lg:inline-flex" data-id="element-112" data-mp="p3vmdbow07fv">
              Work with me
            </Link>
            <button type="button" aria-label="Open menu" aria-expanded={open} onClick={() => setOpen(true)} className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-charcoal/15 text-charcoal transition-colors duration-300 hover:bg-charcoal/5 lg:hidden" data-id="element-113" data-mp="192drzlbswrw">
              <MenuIcon className="h-4 w-4" strokeWidth={1.4} data-id="element-114" data-mp="2anqzzb2egkfu" />
            </button>
          </div>
        </motion.nav>
      </header>

      <AnimatePresence data-id="element-115" data-mp="25ra9wbbn3w04">
        {open && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.4
      }} className="fixed inset-0 z-[60] bg-ivory lg:hidden" data-id="element-116" data-mp="2jglwngdsx7u0">
            <div className="flex items-center justify-between px-6 pt-8" data-id="element-117" data-mp="2tdgtluuff066">
              <span className="text-[0.8125rem] font-medium uppercase tracking-[0.32em]" data-id="element-118" data-mp="2oevrfpvm66f3">
                Amoye&nbsp;Henry
              </span>
              <button type="button" aria-label="Close menu" onClick={() => setOpen(false)} className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-charcoal/15" data-id="element-119" data-mp="32ddle5c44f5g">
                <XIcon className="h-4 w-4" strokeWidth={1.4} data-id="element-120" data-mp="141oergtru4w2" />
              </button>
            </div>

            <nav className="px-6 pt-14" data-id="element-121" data-mp="15gr64ifuikd6">
              <ul className="space-y-1" data-id="element-122" data-mp="1ag3p2s3lj7ah">
                {nav.map((item, i) => <motion.li key={item.to} initial={{
              opacity: 0,
              y: 18
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.06 * i,
              duration: 0.6,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-123" data-mp="1ai6pm62dkitg" data-mpi={i}>
                    <NavLink to={item.to} className="block border-b border-charcoal/[0.08] py-4 font-serif text-[2.25rem] font-light leading-none text-charcoal" data-id="element-124" data-mp="qsw7klf5pls6">
                      {item.label}
                    </NavLink>
                  </motion.li>)}
              </ul>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </>;
}